export const SET_INCLUDE_PAST_TOURNAMENTS_IN_STATE_FOR_ADMIN_HOME = 'SET_INCLUDE_PAST_TOURNAMENTS_IN_STATE_FOR_ADMIN_HOME';
export const SET_SEARCH_VALUE_IN_STATE_FOR_ADMIN_HOME = 'SET_SEARCH_VALUE_IN_STATE_FOR_ADMIN_HOME';
export const SET_SEARCH_RESULT_IN_STATE_FOR_ADMIN_HOME = 'SET_SEARCH_RESULT_IN_STATE_FOR_ADMIN_HOME';
export const SET_SEARCH_BY_SELECTED_FOR_ADMIN_HOME = 'SET_SEARCH_BY_SELECTED_FOR_ADMIN_HOME';


// WEBPACK FOOTER //
// ./src/features/admin/home/constants.js